@use "ui/styles/colorsOld";
@use "ui/styles/fonts";

.tableWrapper {
  padding: 8px 24px 16px 48px;
}

.contracts {
  display: grid;
  grid-template-columns: minmax(120px, 1.4fr) minmax(80px, 0.8fr) minmax(120px, 1fr) minmax(100px, 0.8fr) auto;
  border: 1px solid colorsOld.$stoneLightX1;
  border-radius: 4px;
  overflow: hidden;
}

.header,
.contract {
  display: contents;
}

.header > * {
  background: colorsOld.$stoneLightX3;
  color: colorsOld.$stoneDarkX1;
  font-size: fonts.$small;
  font-weight: fonts.$bold;
  padding: 10px 6px;

  &:first-child {
    padding-left: 12px;
  }

  &:last-child {
    padding-right: 12px;
  }
}

.contract > * {
  // stretch (not align-self: center) so every cell in a row shares the same height — otherwise
  // the border-top divider between rows lands at a different y per column, since the actions
  // cell (two icon buttons) is taller than the plain text cells.
  display: flex;
  align-items: center;
  color: colorsOld.$stoneDarkX1;
  font-size: fonts.$mid;
  padding: 10px 6px;

  &:first-child {
    padding-left: 12px;
  }

  &:last-child {
    padding-right: 12px;
  }
}

.contract + .contract > * {
  border-top: 1px solid colorsOld.$stoneLightX1;
}

.actions {
  display: flex;
  gap: 4px;
}

.cardList {
  > * {
    margin-bottom: 8px;
  }
}

.card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid colorsOld.$stoneLightX1;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: fonts.$small;
  color: colorsOld.$stone;
}

.cardInfo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.cardTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: fonts.$mid;
  color: colorsOld.$stoneDarkX1;
  overflow-wrap: break-word;
}

.cardMenu {
  flex-shrink: 0;
}

.form {
  display: grid;
  gap: 12px;
}

.totalPriceOverrideToggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 900px) {
  .header {
    display: none;
  }

  .contracts {
    grid-template-columns: 1fr;
  }
}
